// extracted by mini-css-extract-plugin
export default {"SearchControlPanel":"SearchControlPanel_SearchControlPanel__th1sj"};